import axios from "axios";

import Constantes from 'configs/constantes';
import Urls from 'configs/urls';
import Language from 'helpers/Language';

const http = axios.create({
	baseURL: Urls.api
});

class Api {
	cancelTokenSource = false;

	post(object, url, callback) {
		this.cancelTokenSource = axios.CancelToken.source();

		return this.request(object, url,
			callback,
			http.post,
			{},
			() => {
			},
			{
				cancelToken: this.cancelTokenSource.token
			}
		);
	}

	get(object, url, callback) {
		this.cancelTokenSource = axios.CancelToken.source();

		return this.request({
			params: object,
			cancelToken: this.cancelTokenSource.token
		}, url, callback, http.get);
	}

	delete(object, url, callback) {
		return this.request(object, url, callback, http.delete);
	}

	put(object, url, callback) {
		return this.request(object, url, callback, http.put);
	}

	upload(object, url, callback, progress) {
		return this.request(object, url, callback, http.post, {
			'Content-Type': 'multipart/form-data'
		}, progress);

	}

	updateToken(callback) {
		this.post({
			username: process.env.REACT_APP_API_LOGIN,
			password: process.env.REACT_APP_API_PASSWORD
		}, 'login_check', callback);
	}

	startLoopProperty(o, end) {
		this.loopProperty(0, o, [...Object.keys(o)], end);
	}

	nextProperty(index, obj, keys, end) {
		if (index < (keys.length - 1)) {
			this.loopProperty(index + 1, obj, keys, end);
			return true;
		}
		end(obj);
	}

	loopProperty(index, obj, keys, end) {
		let key = keys[index];
		let value = obj[keys[index]];
		if (typeof value === 'object' && value !== null) {
			this.loopProperty(0, obj[keys[index]], Object.keys(obj[keys[index]]), () => {
				this.nextProperty(index, obj, keys, end);
			});
			return;
		}

		//TODO UPDATE API
		if (
			typeof value === 'string' && value.indexOf('/api/media_objects/') !== -1 && key !== '@id'
		) {
			this.get({}, (value + '').replace('api/', ''), (error, media) => {
				if (!error) {
					media.contentUrl = Urls.home + media.contentUrl.substring(1);
					obj[keys[index]] = media;
				}
				this.nextProperty(index, obj, keys, end);
			});
			return;
		}
		this.nextProperty(index, obj, keys, end);
	}

	request(object, url, callback, httpRequest = http.post, headers = {}, progress, configs) {
		http.defaults.headers.common['Authorization'] = 'Bearer ' + Constantes.getToken();

		if (typeof progress !== 'function') {
			progress = () => {
			};
		}
		const updateToken = () => {
			this.updateToken((error, response) => {
				if (!error) {
					Constantes.setToken(response.token);
					this.request(object, url, callback, httpRequest);
				}
			})
		}

		if(typeof object.params !== 'undefined'){
			object.params = {
				...object.params,
				lang: Language.getUrlLanguage()
			}
		}

		httpRequest(
			url,
			object,
			{
				headers,
				onUploadProgress: progress,
				...configs
			}
		)
			.then((response) => {
					if (response.status === 401) {
						if (Constantes.isDev()) {
							return updateToken();
						}
						document.location.href = '/auth/logout';
						return;
					}
					if (response.status === 200 || response.status === 201 || response.status === 204) {
						if (
							typeof (object.params) !== 'undefined' &&
							typeof (object.params.itemsPerPage) !== 'undefined'
						) {
							callback(false, response.data);
							return;
						}
						return callback(false, response.data);
						//REMOVE MAKE WITH API
						/*return this.startLoopProperty({...response.data}, (obj) => {
							callback(false, obj);
						});*/
					}
					callback('Response statut failed', false);
				}
			)
			.catch((error) => {
				if (axios.isCancel(error)) {
					return;
				}

				if (
					typeof (error) !== 'undefined' &&
					typeof (error.response) !== 'undefined' &&
					typeof (error.response.status) !== 'undefined'
				) {
					if (error.response.status === 401) {
						if (Constantes.isDev()) {
							return updateToken();
						}
						document.location.href = '/auth/logout';
						return;
					}
					if (error.response.status === 500) {

						if (Constantes.isDev()) {

						} else {
							//document.location.href = '/';
						}
					}
					if (error.response.status >= 400 && error.response.status <= 500) {
						if (typeof (error.response.data['violations']) !== 'undefined') {
							return callback(true, error.response.data['violations']);
						}

						if (typeof error.response.data['hydra:description'] !== 'undefined') {
							return callback(true, error.response.data['hydra:description']);
						}
					}
					if (error.response && error.response.data && error.response.data.message) {
						return callback(true, error.response.data.message);
					}
				}
				console.log(error);
				callback(true, 'Une erreur s\'est produite');
			});

		return this.cancelTokenSource;
	}
}

export default new Api();
